/** Small display formatters shared by pages. */

const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto", style: "short" });
const UNITS: Array<[Intl.RelativeTimeFormatUnit, number]> = [
  ["day", 86_400],
  ["hour", 3_600],
  ["minute", 60],
  ["second", 1],
];

/** "4 s ago", "3 hr. ago"; "—" for null. */
export function timeAgo(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return "—";
  const diffS = Math.round((new Date(iso).getTime() - now) / 1000);
  for (const [unit, size] of UNITS) {
    if (Math.abs(diffS) >= size || unit === "second") {
      return rtf.format(Math.round(diffS / size), unit);
    }
  }
  return "—";
}

/** Seconds since an ISO timestamp (null when unknown). */
export function ageSeconds(iso: string | null | undefined, now = Date.now()): number | null {
  if (!iso) return null;
  return Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
}

/** 74 → "74 s", 3700 → "1 h 1 m". */
export function formatDuration(seconds: number): string {
  if (seconds < 60) return `${Math.round(seconds)} s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)} m ${Math.round(seconds % 60)} s`;
  return `${Math.floor(seconds / 3600)} h ${Math.floor((seconds % 3600) / 60)} m`;
}

const nf = new Intl.NumberFormat();
export function formatNumber(n: number): string {
  return nf.format(n);
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}

/** "1 mapping" / "3 mappings". */
export function plural(n: number, one: string, other = `${one}s`): string {
  return `${formatNumber(n)} ${n === 1 ? one : other}`;
}
